import React, { Component } from "react";

const getImage = function (uri) {
    return `/api/v1/media/download/${uri}`;
};

const getDownloadUri = function (uri) {
    return `https://kbr.creativecore.eu/api/v1/media/download/${uri}`;
}

const resizeImage = function (uri, width, height) {
    return `https://transform.kbr.creativecore.eu/insecure/resize:fit:${width}:${height}/plain/${encodeURIComponent(getDownloadUri(uri))}@jpg`;
};

function Imagable(WrappedComponent) {
    return class extends Component {
        render() {
            return <WrappedComponent getImage={getImage} resizeImage={resizeImage} {...this.props} />;
        }
    };
}

export default Imagable;
